import React from 'react'
import Icon from 'react-icon-base'

const Skill = props => (
  <Icon viewBox="0 0 40 40" {...props}>
    <g id="Skill" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Skill" transform="translate(-125.000000, -2013.000000)">
        <rect id="Rectangle" fill="#F1F1F1" x="0" y="8" width="1200" height="3822" />
        <g id="Group" transform="translate(32.000000, 410.000000)">
          <g id="Skill" transform="translate(0.000000, 1452.000000)">
            <rect
              id="Rectangle-Copy-2"
              stroke="#DDDDDD"
              fill="#FFFFFF"
              x="0.5"
              y="0.5"
              width="1135"
              height="361"
              rx="4"
            />
            <g id="Group-16" transform="translate(26.000000, 152.000000)" stroke="#3498DB" strokeLinejoin="round">
              <g id="Group-3" transform="translate(68.000000, 0.000000)">
                <g
                  id="Page-1-Copy-3"
                  transform="translate(8.000000, 13.000000)"
                  strokeLinecap="round"
                  strokeWidth="2.05062041">
                  <path
                    d="M15,5.52631579 C15,2.47468421 12.5253158,0 9.47368421,0 C6.42205263,0 3.94736842,2.47468421 3.94736842,5.52631579 C3.94736842,8.57794737 6.42205263,11.0526316 9.47368421,11.0526316 C12.5253158,11.0526316 15,8.57794737 15,5.52631579 Z"
                    id="Stroke-1"
                  />
                  <path
                    d="M18.9473684,20.5263158 C18.9473684,15.2946293 14.7053707,11.0526316 9.47368421,11.0526316 C4.24199769,11.0526316 0,15.2946293 0,20.5263158"
                    id="Stroke-3"
                  />
                </g>
                <polygon
                  id="Star-Copy"
                  strokeWidth="1.5"
                  points="17.5 8.305 14.2671811 9.94959347 14.8322865 6.36679267 12.2691892 3.80040653 15.8512624 3.23070733 17.5 0 19.1487376 3.23070733 22.7308108 3.80040653 20.1677135 6.36679267 20.7328189 9.94959347"
                />
                <g id="Group" transform="translate(3.000000, 8.000000)" strokeWidth="1.125">
                  <polygon
                    id="Star-Copy-2"
                    points="25 6.04 22.648859 7.23606798 23.0598447 4.63039467 21.1957739 2.76393202 23.8009181 2.34960533 25 0 26.1990819 2.34960533 28.8042261 2.76393202 26.9401553 4.63039467 27.351141 7.23606798"
                  />
                  <polygon
                    id="Star-Copy-4"
                    points="4 6.04 1.64885899 7.23606798 2.05984471 4.63039467 0.195773935 2.76393202 2.80091809 2.34960533 4 0 5.19908191 2.34960533 7.80422607 2.76393202 5.94015529 4.63039467 6.35114101 7.23606798"
                  />
                </g>
                <g id="Group-2" transform="translate(0.000000, 18.000000)" strokeWidth="1.125">
                  <polygon
                    id="Star-Copy-3"
                    points="32 4.53 30.2366442 5.42705098 30.5448835 3.472796 29.1468305 2.07294902 31.1006886 1.762204 32 0 32.8993114 1.762204 34.8531695 2.07294902 33.4551165 3.472796 33.7633558 5.42705098"
                  />
                  <polygon
                    id="Star-Copy-5"
                    points="3 4.53 1.23664424 5.42705098 1.54488353 3.472796 0.146830451 2.07294902 2.10068856 1.762204 3 0 3.89931144 1.762204 5.85316955 2.07294902 4.45511647 3.472796 4.76335576 5.42705098"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </Icon>
)

Skill.defaultProps = {
  size: 30
}

export default Skill
